import BaseModal from '../base-modal/index'
const baseModal = new BaseModal()

export default class {
  constructor() {
    this.state = {
      showDeleteModal: false,
      ...baseModal.state
    }
    this.getters = { ...baseModal.getters }
    this.mutations = {
      ...baseModal.mutations,
      SHOW_DELETE_MODAL: (state, res) => {
        state.showDeleteModal = res.visible
      }
    }
    this.actions = {
      ...baseModal.actions,
      setShowDeleteModal: ({ commit }, params) => {
        commit('SHOW_DELETE_MODAL', params)
      }
    }
  }
}
